import React, { useState, useEffect } from "react";
import "./Slider.css";
import { VscArrowRight, VscArrowLeft } from "react-icons/vsc";
import SliderImg1 from "../../Assets/sliderImg1.jpg";
import SliderImg2 from "../../Assets/sliderImg2.jpg";
import SliderImg3 from "../../Assets/sliderImg3.jpg";
import SliderImg4 from "../../Assets/sliderImg4.jpg";
import SliderImg5 from "../../Assets/sliderImg5.jpg";
import SliderImg6 from "../../Assets/sliderImg6.jpg";

const Slider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [
    {
      image: SliderImg1,
      h1: "Green Youth Movement",
      text: "Green Youth Movement aims to sensitize youth to climate change, the environment, and our impact on the planet. Executed through HEC-Islamabad, GYM aims to develop Green Clubs in all public sector HEIs of Pakistan.",
      btn1: "Read More",
    },
    {
      image: SliderImg2,
      h1: "Youth Organizations Registration",
      text: "This Programme is formally initiating the process of getting nominations of the youth led groups and organisations to facilitate productive engagement of young people for the promotion of national cohesion and inclusion.",
      btn1 : "",
    },
    {
      image: SliderImg3,
      h1: "Mobile App",
      text: " PMYP Mobile App is a platform to discover the world of opportunities. Youth can find job opportunities, career counselling, and all the information related to different initiatives of the Prime Minister's Youth Programme in a single mobile application.",
      btn1: "Download App",
    },
    {
      image: SliderImg4,
      h1: "Talent Hunt Youth Sports League",
      text: "Sports can play critical role in transforming the youth into a self-confident, organized, and capable workforce that can bring positive social change and economic well-being in the country.",
      btn1: "Read More",
    },
    {
      image: SliderImg5,
      h1: "National Innovation Award",
      text: "National Innovation Award is an opportunity for young entrepreneurs to present their innovative ideas related to 8 thematic areas with a specific focus on Eco-Innovation.",
      btn1: "Read More",
    },
    {
      image: SliderImg6,
      h1: "Prime Ministers Youth Business Loans",
      text: "Prime Minister's Youth Business Loans support youth and their entrepreneurial mindset by providing easy access to business loans. The loans are provided on simple terms and with less markup through 21 Commercial, Islamic, and SME banks.",
      btn1: "Read More",
    },
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);
    return () => clearInterval(intervalId);
  }, [currentIndex]);

  const handlePrevClick = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNextClick = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handleDotClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="carousel-container1">
      <div className="image-container1">
        {images.map((item, index) => (
          <div
            key={index}
            className="slide1"
            style={{ display: index === currentIndex ? "block" : "none" }}
          >
            <img src={item.image} alt={item.text} />
              <h1>{item.h1}</h1>
              <p>{item.text}</p>
              {item.btn1 ==="" ? (
                null
              ) : <>
                  <button>{item.btn1}</button>
                </>
                }
          </div>
        ))}
        <button className="prev-button1" onClick={handlePrevClick}>
         <VscArrowLeft/>
        </button>
        <button className="next-button1" onClick={handleNextClick}>
          <VscArrowRight/>
        </button>
      </div>
      <div className="dot-container1">
        {images.map((image, index) => (
          <span
            key={index}
            className={index === currentIndex ? "dot active" : "dot"}
            onClick={() => handleDotClick(index)}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Slider;
